export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ02.fe969a5a.mp3";